module.exports = __webpack_public_path__ + "static/img/service-code.1d4a96e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/footer/service-code.png
// module id = auIr
// module chunks = 32